import type { OrderChatMessage } from '~/types/order-chat-message'

export function parseBusinessOrderMessage(raw: string): OrderChatMessage | null {
    try {
        const parsed = JSON.parse(raw) as unknown
        if (!parsed || typeof parsed !== 'object') {
            return null
        }
        const message = parsed as OrderChatMessage
        if (typeof message.id !== 'number') {
            return null
        }
        return message
    }
    catch {
        return null
    }
}
